import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('student');

export class PreRegister extends Api {
  constructor(http, config = {}) {
    super(http, url, 'pre-register', config);
  }

  findByIdentification (config = {}) {
    config = {...this._config, ...config};
    const uri = `${url}/pre-register-by-identification`
    
    return this._http.get(uri, config);
  }
}
